<div class="px-4 pb-3 pt-0 overflow-y-auto zuper-scrollbar bg-white property-quick-create-form" *ngIf="propertyForm">
    <div class="">
        <form class="flex flex-wrap divide-y divide-gray-200" autocomplete="off" [formGroup]="propertyForm">
            <div class="flex flex-wrap w-full py-3" *ngFor="let header of createProperty;let i=index">
                <label *ngIf="header.canShow"
                    class="text-gray-700 truncate font-bold text-base">{{header.headerDisplayKey
                    |
                    translate}}</label>
                <div class="flex w-full flex-wrap" *ngIf="header.headerType !== 'address'">
                    <div class="px-2 py-3" [ngClass]="field.cssClass ? field.cssClass : 'field-container-half-width'"
                        *ngFor="let field of header.formFields;let i=index">
                        <!-- Basic Field Type -->
                        <div class="field-full-width quick-create-form-field" *ngIf="field.fieldType === 'input'">
                            <label for="{{field.fieldId}}" class="block text-base font-medium text-gray-700">{{field.labelDisplayKey |
                                translate}}<span *ngIf="field.isMandatory" class="mandatory-field">*</span>
                            </label>
                            <input id="{{field.fieldId}}" type="{{field.inputType}}" [formControlName]="field.formControlName"
                                class="mt-1 block w-full rounded-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base"
                                placeholder="{{field.placeHolderDisplayKey | translate}}">
                            <p class="text-red-500 text-base mt-1 primary-font" *ngIf="showError(field.formControlName)">{{getErrorMessageKey(field)
                                |
                                translate}}</p>
                        </div>
                        <!-- AutoComplete Lazy Loading Field Type -->
                        <div *ngIf="field.fieldType === 'lazyautocomplete' && field?.showIf">
                            <label class="block text-base font-medium text-gray-700">{{field.labelDisplayKey |
                                translate}}<span *ngIf="field.isMandatory" class="mandatory-field">*</span>
                            </label>
                            <ng-select class="text-base pt-0.5"
                                placeholder="{{field.placeHolderDisplayKey | translate}}" bindValue="{{field.oberservableValue}}"
                                [formControlName]="field.formControlName" [items]="getObservable() | async"
                                [loading]="field.allowLoading ? loading : false" bindLabel="{{field.oberservableKey}}"
                                [typeahead]="field.valueSubject ? field.valueSubject : null" (clear)="onClear()"
                                (search)="onSearch(field.valueSubject)"
                                (scrollToEnd)="field.allowLazyLoading ? onScrollToEnd() : null">
                            </ng-select>
                        </div>
                    </div>
                </div>
                <div class="w-full" *ngIf="header.headerType === 'address'">
                    <contact-info [fields]="header.contactFields" [addressFormGroupName]="header.formGroupName">
                    </contact-info>
                </div>
            </div>
        </form>
    </div>
</div>